<template>
  <div>
    <div class="support-ticket-container">
      <header class="support-ticket-header">
        <div class="d-flex w-100 align-items-center justify-content-between">
          <div>
            <img src="@/assets/img/logos/logo-dark.png" width="85" />
          </div>
          <router-link
            class="btn-outline-blue"
            to="/add-mobile-support-ticketing"
          >{{ $tc('add') }} New Ticket</router-link>
        </div>
      </header>

      <div class="section-title text-center mb-4">Welcome to Support Ticket</div>

      <div class="row py-2">
        <div class="col-6">
          <b-dropdown :text="selectedstatus" class="w-100" variant="outline-blue">
            <b-dropdown-item
              v-for="(st, stIndex) in status"
              :key="stIndex"
              @click="OnSelect(st)"
            >{{ st.name }}</b-dropdown-item>
          </b-dropdown>
        </div>

        <div class="col-6">
          <b-dropdown
            name="listview"
            right
            id="listview"
            class="w-100"
            variant="outline-blue w-100"
          >
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{selectedvalue}}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              :key="listIndex"
              v-for="(list, listIndex) in viewingnumbers"
              @click="onDropDownChangeValue(list.name)"
            >{{list.name}}</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>

      <div class>
        <div class="col-12 px-0 border-bottom" v-for="(ticket,ticketIndex) in TicketList" :key="ticketIndex">
          <div class="btn-support-ticket" v-b-toggle="'collapse'+ticketIndex">
            <span class="text-success">&bull;</span>
            <!-- <strong>Need some additions cups, Existing Cups got damaged</strong> -->
            <strong>{{ticket.stm_subject}}</strong>

            <img src="@/assets/img/icons/primary/chevron-down.svg" height="20" width="20" />
          </div>

          <b-collapse :id="'collapse'+ticketIndex">
            <div class="st-additionl-details row">
              <div class="col-6 custom-padding-left pr-0">
                <label class="small text-muted mb-1">Category</label>
                <!-- <p>Food And Beverages</p> -->
                <p>{{ticket.stc_name}}</p>

              </div>

              <div class="col-6 custom-padding-right">
                <label class="small text-muted mb-1">Requester</label>
                <!-- <p>Super Admin</p> -->
                <p>{{ticket.first_name}}&nbsp;{{ticket.last_name}}</p>

              </div>

              <div class="col-6 mb-2 custom-padding-left pr-0">
                <label class="small text-muted mb-1">Request Date</label>
                <!-- <p>20 - Jan - 2020</p> -->
                <p>{{ticket.created_at | dateparse}}</p>

              </div>

              <div class="col-6 mb-2 custom-padding-right">
                <label class="small text-muted mb-1">Status</label>
                <!-- <p class="text-danger">Unresolved</p> -->
                <p class="text-danger">{{ticket.st_status}}</p>
              </div>

              <div class="col-12 mb-4 custom-padding-both">
                <router-link :to="{path:'/edit-mobile-support-ticketing',query: {
          id: ticket.st_id,
          status: ticket.st_status
        }}" class="btn btn-sm btn-blue w-100 mx-0">Respond to this Query</router-link>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>

      <div class>
        <table class="table table-striped table-responsive">
          <thead>
            <tr>
              <th colspan="3">Subject</th>
              <th>Category</th>
              <th>Requester</th>
              <th>Requested</th>
              <th>{{ $tc('status', 1) }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ticket, ticketIndex) in AllTickets" :key="ticketIndex">
              <td colspan="3">{{ ticket.stm_subject }}</td>
              <td>{{ ticket.stc_name }}</td>
              <td>{{ ticket.first_name }} {{ ticket.middle_name }} {{ ticket.last_name }}</td>
              <td>{{ ticket.created_at | dateparse }}</td>
              <td>
                <div class="d-flex justify-content-between">
                  <div>{{ ticket.st_status }}</div>

                  <div>
                    <b-dropdown right variant="edit" class="ml-4">
                      <b-dropdown-item @click="goToRoute('/edit-mobile-support-ticketing', ticket)">
                        <span class="edit-pen"></span>
                        {{ $t('respond') }}
                      </b-dropdown-item>
                      <!-- <b-dropdown-item
                      @click="goToRoute('/view-mobile-support-ticketing', ticket)"
                    >
                      <span class="icon-eye"></span>
                      {{ $t('view') }}
                      </b-dropdown-item>-->
                    </b-dropdown>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          @change="onChangePagination($event)"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>


<script>
import "@/assets/css/supportTicket.css";
import CinemasService from "@/services/CinemasService";

export default {
  data() {
    return {
      perPage: 10,
      filterListBy: "",
      currentPage: 1,
      rows: 0,
      selectedvalue: "",
      selectedstatus: "Filter by",
      selectedid: "",
      status: [
        { id: 0, name: "Resolved" },
        { id: 1, name: "Unresolved" }
      ],
      TicketList: []
    };
  },
  beforeMount() {
    this.GetAllTickets();
    this.getviewingnumber();
  },
  computed: {
    AllTickets() {
      let filteredList = [];

      if (this.selectedstatus.length > 0) {
        this.TicketList.map(x => {
          if (x.st_status == this.selectedstatus) {
            filteredList.push(x);
          }
        });
        return filteredList;
      } else {
        return this.TicketList;
      }
    }
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.GetAllTickets();
      } else {
        this.currentPage = event;
        this.GetAllTickets();
      }
    },
    goToRoute: function(path, item) {
      this.$router.push({
        path: path,
        query: {
          id: item.st_id,
          status: item.st_status
        }
      });
    },

    OnSelect: function(data) {
      this.selectedstatus = data.name;
    },

    GetAllTickets: function() {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage
      };
      let loader = this.$loading.show();

      CinemasService.GetTickets(payload)
        .then(response => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.TicketList = data.Records;

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    }
  }
};
</script>
 


// WEBPACK FOOTER //
// src/components/Pages/mobileSupportTicketComponent/mobileSupportTicketing.vue